<mat-form-field #formFieldContainer  class="classGblNoteBox divNoteBoxContainer">
  <mat-label
    #labelContainer  (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">
      {{componentDefinition?.label}}
  </mat-label>
  <div class="labelToolTipContainer"
    #tooltip="matTooltip"
    matTooltip="{{componentDefinition.label}}"
    [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>
  <mat-progress-bar *ngIf="
              formControl.value  &&
              componentDefinition?.visualCharacterCount &&
              (progressPercentageValue!==100)" mode="determinate"
                    [value]="progressPercentageValue"></mat-progress-bar>
  <mat-hint *ngIf="componentDefinition?.displayCharacterCount" align="end" title="charactersCountDisplay">
    <span class="counter-class">{{charactersCountDisplay}}</span>
  </mat-hint>
  <!-- Textarea input for limitCharacter entry -->
  <div class="divNoteBoxResizeContainer{{fieldName}}{{key}} {{(noteBoxRows==-1) ? 'grow-wrap' : ''}}" >
  <textarea matInput
            class="hidden-print"
            #taLimitCharacterCount *ngIf="(limitCharacterCount>0)" [rows]="(noteBoxRows>0)?noteBoxRows:3"
            [maxLength]="limitCharacterCount"
            [id]="fieldName + document.documentId" [name]="fieldName"
            [formControl]="formControl"
            (input)="fnNoteBoxChanged($event)"
            style="transform: translateZ(0px);"></textarea>
  <!-- Textarea input for no limit maxlength -->
  <textarea matInput
            class="hidden-print"
            #taNoLimitCharacterCount *ngIf="!(limitCharacterCount>0)" [rows]="(noteBoxRows>0)?noteBoxRows:3"
            [id]="fieldName + document.documentId" [name]="fieldName"
            [formControl]="formControl"
            (input)="fnNoteBoxChanged($event)"
            style="transform: translateZ(0px);"></textarea>
  </div>
  <p class="note-box-copy visible-print">
    {{fieldValue}}
  </p>

</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
